import { TOAST_DUCK, TOAST_STATE } from '../../core/actions'

export const ToastInitialState = {
  message: '',
  type: '',
}

export const ToastReducer = (state, { type, payload }) => {
  switch (type) {
    case TOAST_DUCK.SEND_TOAST:
      return { ...state, message: payload.message, type: payload.type || TOAST_STATE.INFO }
    case TOAST_DUCK.EOL:
      return { ...ToastInitialState }
    default:
      return state
  }
}
